import SmallConfirmPopup from "./SmallConfirmPopup.component.jsx";

export default SmallConfirmPopup;